/**
 * Resets form
 * @param {HTMLFormElement} form
 * @param {handleTabSwitch} store
 * @returns {Promise<void>}
 */
async function resetForm(form, store) {
	const formId = form.id;

	// remove from localstorage
	removePersistedForm(formId);

	// Go to first tab
	store.goToTab(0);

	// clear errors
	clearAllMessages(form);

	// reset form
	form.reset();

	// reset autocomplete groups
	const CACHE_KEY = 'autocomplete-groups';
	const groups = cache().getItem(CACHE_KEY);
	if (groups) {
		for (const group of Object.values(groups)) {
			const emptyObject = Object.keys(group.state.queryObject).reduce((acc, currentValue) => {
				return { ...acc, [currentValue]: null }
			}, {});
			group.updateQueryObject(emptyObject);
			group.updateAutocompleteData(emptyObject);
		}
	}

	// reset dropzones
	window.dropzones = window.dropzones || [];
	window.dropzones.forEach((dropzone) => {
		dropzone.removeAllFiles();
	})

	// Refresh discount button disability
	form.querySelectorAll('input.input--discountfield').forEach((input) => handleDiscountButtonDisability(input))

	// Refresh all conditionals
	refreshConditionalRelatedElements(form);

	// Fill form with data from query params
	const dataWithQueryParams = updateDataWithQueryParams(form, {});
	fillFormWithData(form, dataWithQueryParams);

	// Generate new contract id
	form.querySelector(`[name="contract-id"]`).value = await getContractId();
}
